import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RadioList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Input = styled.input<{ disabled: boolean }>`
  appearance: none;
  background-color: white;
  margin: 0;
  width: 22px;
  height: 22px;
  border: 2px solid #d4d4d8;
  border-radius: 50%;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  position: relative;
  transition: all 0.2s ease;

  &:checked {
    border: 2px solid #4d4be7;
    background: white;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #4d4be7;
    }
  }

  &:focus-visible {
    outline: 2px solid #4d4be7;
    outline-offset: 2px;
  }

  &:hover {
    border-color: ${({ disabled }) => (disabled ? '#d4d4d8' : '#4d4be7')};
  }

  &:disabled {
    opacity: 0.8;
  }
`

export const Label = styled.label<{ disabled: boolean }>`
  color: ${({ disabled }) => (disabled ? '#d4d4d8' : '#14171f')};

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;

  &:hover {
    color: ${({ disabled }) => (disabled ? '#d4d4d8' : '#4d4be7')};
  }
`

export const LabelGroup = styled.div`
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
